<template>
  <span ref="mainChip" @click="handleClick">
    <v-tooltip
      content-class="details-country-chip"
      v-model="expanded"
      right
      :position-x="posX"
      :position-y="posY"
      :transition="'none'"
      absolute
    >
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          small
          class="mx-0 px-1 chip"
          :class="{ 'dark-chip': isDark, 'light-chip': !isDark }"
          :dark="isDark"
          color="primary"
          v-bind="attrs"
          v-on="on"
          outlined
          @mouseover="mouseOver()"
          @mouseleave="mouseLeave()"
          :open-on-hover="false"
        >
          <img
            v-if="flagUrl"
            :src="flagUrl"
            height="16"
            style="border: 1px solid #d1d1d1; border-radius: 7px;"
            class="mr-1"
          />
          <div class="smallChipText">{{ code }}</div>
        </v-chip>
      </template>
      <span
        ><v-chip
          small
          class="mx-0 px-1 chip"
          :class="{ 'dark-chip': isDark, 'light-chip': !isDark }"
          :dark="isDark"
          color="primary"
          :style="{ 'min-width': hoverMinWidth }"
          outlined
        >
          <img
            v-if="flagUrl"
            :src="flagUrl"
            height="16"
            style="border: 1px solid #d1d1d1; border-radius: 7px;"
            :data-country-code="code"
            class="mr-1"
          />
          <div class="smallChipText">{{ name }}</div>
        </v-chip></span
      >
    </v-tooltip>
  </span>
</template>

<script>
import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";
import { EVENT_ACTIONS } from "@/common/constants/analytics";
import { hasGrdAccess } from "@/services/user/user.service";

const EMITTED_ACTIONS = {
  AFTER_CLICK: "after-click",
};

export default {
  name: "DetailsListItemCountryChip",
  props: {
    name: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
    },
    flagUrl: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
    },
  },
  data() {
    return {
      expanded: false,
      posX: 0,
      posY: 0,
      hoverMinWidth: 0,
    };
  },
  computed: {
    ...mapGetters({
      selectorPanel: MODULE_PREFIX_HOME + "selectorPanel",
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    isDark() {
      return this.theme === "dark";
    },
  },
  methods: {
    getTipClass: (index) => {
      return "row" + (index + 1);
    },
    mouseOver() {
      this.expanded = true;
      window.addEventListener(
        "wheel",
        () => {
          this.mouseLeave();
        },
        { once: true }
      );
      this.updatePos();
    },
    mouseLeave() {
      this.expanded = false;
      this.updatePos();
    },
    updatePos() {
      if (this.$refs.mainChip) {
        this.posX =
          this.$refs.mainChip.getBoundingClientRect().left -
          this.$refs.mainChip.getBoundingClientRect().width / 2 +
          4;
        this.posY =
          this.$refs.mainChip.getBoundingClientRect().top +
          this.$refs.mainChip.getBoundingClientRect().height / 2 +
          1;

        this.hoverMinWidth =
          this.$refs.mainChip.getBoundingClientRect().width + "px";
      }
    },
    handleClick(evt) {
      evt.preventDefault();

      this.detailsSidebar.visible = false;
      this.selectorPanel.selected = hasGrdAccess()
        ? "grdCountries"
        : "stability";
      this.selectorPanel.visible = true;
      this.selectorPanel.selectedData = {
        code: this.code,
      };

      if (this.analyticsCategory) {
        this.handlePageTrackerEvent(
          this.analyticsCategory,
          EVENT_ACTIONS.clicked,
          `${this.name}`
        );
      }

      this.$emit(EMITTED_ACTIONS.AFTER_CLICK);
    },
  },
};
</script>

<style scoped lang="scss">
.chip {
  width: 100%;
  margin-bottom: 2px;
  cursor: pointer;
}
.v-chip.v-chip--outlined.v-chip.v-chip {
  font-size: 11px !important;
  border-color: $primary-color !important;
}
.v-chip.v-chip--outlined.v-chip.v-chip.dark-chip {
  background-color: black !important;
}
.v-chip.v-chip--outlined.v-chip.v-chip.light-chip {
  background-color: white !important;
}
</style>
